import * as React from 'react';
import { Box, Paper } from '@mui/material';

import { Loading } from 'components/loading';
import { DashboardMetricCardTitle } from './dashboard-metric-card-title';

interface DashboardMetricCardWrapperProps {
  children?: React.ReactNode;
  title?: string;
  subtitle?: string;
  loading?: boolean;
  loadingText?: string;
}

export const DashboardMetricCardWrapper = ({
  children,
  title = '',
  subtitle = '',
  loading = false,
  loadingText = '',
}: DashboardMetricCardWrapperProps) => {
  return (
    <Paper sx={{ padding: 2, display: 'flex', flexDirection: 'column', width: '100%', minHeight: 340 }}>
      <DashboardMetricCardTitle title={title} subtitle={subtitle} />

      <Box sx={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', paddingY: 2 }}>
        {loading ? <Loading text={loadingText} /> : children}
      </Box>
    </Paper>
  );
};
